export const USER_ACTIVITY_UPDATE_REQUESTED = 'USER_ACTIVITY_UPDATE_REQUESTED';
export const USER_ACTIVITY_UPDATE_COMPLETED = 'USER_ACTIVITY_UPDATE_COMPLETED';
export const USER_ACTIVITY_UPDATE_FAILED = 'USER_ACTIVITY_UPDATE_FAILED';
